import dynamic from 'next/dynamic';

// Hooks
import useAcl from '@/hooks/user/useAcl';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';

// Components
import Button from '@/components/base/Button';
const AddSocialProfilesFunnelModal = dynamic(
    () => import('@/components/composite/SocialProfiles/AddSocialProfilesFunnelModal')
);

// Types
import type { Dispatch, SetStateAction } from 'react';

import type { SocialProfileNetworkType } from '@/types/socialProfileType';

type AddSocialProfilesType = {
    isOpen: boolean;
    network: SocialProfileNetworkType;
    idSocialProfileAdded?: number;
};

type AddSocialProfilesActionProps = AddSocialProfilesType & {
    setState: Dispatch<SetStateAction<AddSocialProfilesType>>;
};

const AddSocialProfilesAction = ({
    isOpen,
    network,
    idSocialProfileAdded,
    setState
}: AddSocialProfilesActionProps) => {
    const { t } = useTranslation('socialprofiles');
    const { hasAcl } = useAcl();

    if (!hasAcl(aclFeatures.social_profile.base.create)) {
        return null;
    }

    const handleFunnelModalToggle = (open: boolean) => {
        setState({
            network: null,
            isOpen: open
        });
    };

    return (
        <>
            <Button
                id="add-social-profiles"
                size={'sm'}
                icon={'plus-border'}
                className="mt-4 sm:mt-0"
                onClick={() => handleFunnelModalToggle(true)}>
                {t('add_social_profiles')}
            </Button>
            <AddSocialProfilesFunnelModal
                isOpen={isOpen}
                network={network}
                idSocialProfileAdded={idSocialProfileAdded}
                toggle={() => handleFunnelModalToggle(false)}
            />
        </>
    );
};

export default AddSocialProfilesAction;
